import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DeleteButtonComponent } from 'app/shared/components/delete-button/delete-button.component';
import { CargoItemModel } from 'app/shared/models/cargo-item-model';
import { FalCargoService } from 'app/shared/services/fal-cargo.service';
import { LocalDataSource } from 'ng2-smart-table';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cargo-table',
  templateUrl: './cargo-table.component.html',
  styleUrls: ['./cargo-table.component.css']
})
export class CargoTableComponent implements OnInit, OnChanges {
  @Input() cargoItemList: CargoItemModel[];
  @Output() delete = new EventEmitter<any>();

  cargoDataSource: LocalDataSource = new LocalDataSource();

  cargoTableSettings = {
    mode: 'external',
    actions: false,
    attr: {
      class: 'table table-bordered'
    },

    columns: {
      shippingMarks: {
        title: this.translateService.instant('shipping_marks'),
        type: 'html'
      },
      containerIdentification: {
        title: this.translateService.instant('container_id_number'),
        type: 'html'
      },
      numberOfPackages: {
        title: this.translateService.instant('number_of_packages'),
        type: 'html'
      },
      packageType: {
        title: this.translateService.instant('package_type'),
        type: 'html'
      },
      descriptionOfGoods: {
        title: this.translateService.instant('Description of Goods'),
        type: 'html'
      },
      hsCode: {
        title: this.translateService.instant('hs_code'),
        type: 'html'
      },
      grossVolume: {
        title: this.translateService.instant('Gross Volume (M3)'),
        type: 'html'
      },
      grossWeight: {
        title: this.translateService.instant('Gross Weight (KGM)'),
        type: 'html'
      },
      delete: {
        title: this.translateService.instant('delete'),
        type: 'custom',
        filter: false,
        sort: false,
        renderComponent: DeleteButtonComponent,
        onComponentInitFunction: (instance) => {
          instance.delete.subscribe(row => {
            this.deleteCargoItem(row);
          });
        }
      }
    }
  };

  constructor(
    private cargoService: FalCargoService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    const rows = this.generateRows();
    this.cargoDataSource.load(rows);
  }

  ngOnChanges(changes: SimpleChanges) {
    const rows = this.generateRows();
    this.cargoDataSource.load(rows);
  }

  deleteCargoItem(row) {
    /*     this.cargoItemList = this.cargoItemList.filter(entry => entry !== row.cargoItemModel);
        const rows = this.generateRows();
        this.cargoDataSource.load(rows); */
    this.delete.emit(row);
    // this.cargoService.setDataIsPristine(false);
  }

  generateRows() {
    const rowData = this.cargoItemList.map(item => {
      const row = {
        cargoItemModel: item,
        shippingMarks: item.shippingMarks,
        containerIdentification: item.containerIdentification,
        numberOfPackages: item.numberOfPackages,
        packageType: item.packageType.name,
        descriptionOfGoods: item.description,
        hsCode: item.hsCode,
        grossVolume: item.grossVolume,
        grossWeight: item.grossWeight
      };
      return row;
    });
    return rowData;
  }


}



// WEBPACK FOOTER //
// ./src/app/main-content/content-container/port-call/registration/forms/cargo/cargo-table/cargo-table.component.ts